import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import { database } from 'services/firebase/config';
import useMemoCompare from 'hooks/useMemoCompare';

//Read data once
/**
 * Listen to realTime database once
 * @param {string} path
 */
const useRealTimeDB = path => {
  const INITIAL_STATE = {
    status: path ? 'loading' : 'idle',
    data: undefined,
    error: undefined,
  };

  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  const pathCached = useMemoCompare(path, prevPath => {
    return prevPath && path && path === prevPath;
  });

  useEffect(() => {
    const request = async () => {
      if (!pathCached) {
        dispatch({ type: 'idle' });
        return;
      }
      dispatch({ type: 'loading' });

      try {
        const ref = await database.ref(pathCached).once('value');
        dispatch({ type: 'success', payload: ref.val() });
      } catch (error) {
        dispatch({ type: 'error', payload: error });
      }
    };
    request();
  }, [pathCached]);

  return state;
};

export default useRealTimeDB;
